<template>
  <div>

    
    <FormArchivoPlanoGenerate/>
    
    <!-- <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table 
            v-if="itemsAP.length > 0" 
            bordered striped responsive 
            :per-page="perPage" 
            :items="itemsAP"
            :fields="fieldsAP" 
            :sort-by.sync="sortBy" 
            :current-page="currentPage" 
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection" 
            :filter="filter" 
            :filter-included-fields="filterOn" 
            @filtered="onFiltered">
            <template #cell(accion)="data">
              <div class="d-flex justify-content-end">
                <b-button variant="info" size="sm" @click="descargararchivo(data.item.id)">
                  <i class="fas fa-download" style="margin-right: 10px;" title="Descargar"></i>
                </b-button>
              </div>
            </template>
          </b-table>
          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>
        <b-col cols="12" class="mb-2">
          <b-pagination 
            v-if="itemsAP.length > 0" 
            v-model="currentPageModificado" 
            :total-rows="totalRows" 
            :small="true"
            first-number last-number class="mb-0" align="center" 
            prev-class="prev-item" 
            next-class="next-item"
            @change="cambiarPagina">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay> -->
    
  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue';
import actions from "@/assets/utils/utils";
import vSelect from "vue-select";
import axios   from "axios";
import AppBreadcrumb from "@core/layouts/components/AppBreadcrumb.vue"; // Update the path accordingly
import flatPickr     from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { FormArchivoPlanoGenerate } from '../components';

export default {
  components: {
    ...BootstrapVue.components,
    AppBreadcrumb,
    flatPickr,
    vSelect,
    FormArchivoPlanoGenerate
  },
  data() {
    return {
      tokenSeleccionado: null,
      modalShow: false,
      consultarcita: null,
      componenteDinamico: null,
      mostrarLoader: false,
      login_user: "",
      consultardoc: null,
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      chboxsolitem: null,
      sololip: null,
      currentPage: 1,
      tiposeguro: null,
      tipocobertura: null,
      ptiposervicio: [],
      pservicio: null,
      currentPageModificado: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      doctorid: null,
      pacienteid: null,

      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },

      fieldsAP: [
        {
          key: "paciente",
          label: "Paciente",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechaproceso",
          label: "Fecha Proceso",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechainicio",
          label: "Fecha Ini",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "fechafin",
          label: "Fecha Fin",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "tipocobertura",
          label: "Cobertura",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "tipoarchivo",
          label: "Tipo Archivo",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "usuario",
          label: "Usuario",
          sortable: true,
          thClass: "text-center",
          width: "150px",
        },
        {
          key: "accion",
          label: "Accion",
          sortable: true,
          thClass: "text-center",
          width: "150px",
        }
      ],

      token_usuario: "",
      
      itemsAP: [],
      descripcion: "",
    };
  },
  created() {
    // this.comprobarPermisos();
    // this.fetchArchivosPlanos();
    this.setToken();
  },
  mounted() {
    actions.setearTitulo("Generacion Archivo Plano");
  },

  methods: {

    viewItem(tokenAuxiliar) {
      this.tokenSeleccionado = tokenAuxiliar;
      this.modalShow = true;
    },

    onRowSelected(items) {
      this.selected = items;
    },

    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    cambiarPagina(value) {
      const paginaActual = value;
      const limiteSuperior = value * this.perPage;
      const limiteInferior = (value - 1) * this.perPage;
      const desde = limiteInferior;
      const hasta = limiteSuperior;

      this.fetchConsultarDoctor(
        this.consultardoc ? this.consultardoc : "",
        paginaActual,
        desde,
        hasta,
        this.excel_btn,
        this.pdf_btn
      );
    },

    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`;
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },

    // comprobarPermisos() {
    //   if (
    //     localStorage.getItem("permisos").indexOf("consultar_auxiliar") === -1
    //   ) {
    //     this.$router.push({ name: "not-permitted" });
    //   }
    // },
    

    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },

    buscarDoctor() {
      if (this.consultardoc) {
        this.fetchConsultarDoctor(this.consultardoc, 1, 0, 15, "", "");
      }
    },
  },

  watch: {
    currentPage(newPage, oldPage) {
      if (newPage !== oldPage) {
        this.fetchConsultarDoctor(
          this.consultardoc,
          newPage,
          0,
          15,
          this.excel_btn,
          this.pdf_btn
        );
      }
    },
  },
};
</script>

